import React from 'react';
import * as Styled from './styled';
import LeadAgentIcon from 'assets/svg/circle-wavy-check.svg';
import { useLocale } from 'locale';
import { Route } from 'config/routes';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { noop } from 'lodash';
import { AgentDetails } from './leading-agents-carousel';


interface LeadingAgentCardProps {
  officeName: string;
  agentName: string;
  agentLogo: string;
  agentId: string;
  sectionInView?: boolean;
  rootNode?: React.MutableRefObject<HTMLDivElement>;
  onCardExposeEvent?: (d: AgentDetails) => void;
  onClick: () => void;
}

export const LeadingAgentCard: React.FC<LeadingAgentCardProps> = (props) => {
  const {
    officeName,
    agentName,
    agentLogo,
    agentId,
    onClick,
    sectionInView,
    rootNode,
    onCardExposeEvent = noop,
  } = props;

  const { t } = useLocale();
  const [ isVisible, setIsVisible ] = React.useState(false);
  const cardItem = React.useRef<HTMLDivElement>(null);

  useIntersectionObserver(([ entry ]) => {
    setIsVisible(entry.isIntersecting);
  }, [ cardItem ], { threshold: 0, root: rootNode });

  React.useEffect(() => {
    if (isVisible && sectionInView) {
      onCardExposeEvent({ id: agentId, name: agentName, office_name: officeName, is_leading_agent: true });
    }
  }, [ onCardExposeEvent, isVisible, sectionInView, agentId ]);

  return (
    <Styled.Root onClick={onClick} routeName={Route.AgentPage} routeParams={{ id: agentId, source: 'leading_agent_carousel' }}>
      <Styled.AgentLogo url={agentLogo} />
      <Styled.AgentInfo ref={cardItem}>
        <Styled.AgentName weight="bold">
          <span>{agentName}</span>
          <LeadAgentIcon />
        </Styled.AgentName>
        <Styled.OfficeName>
          {officeName}
        </Styled.OfficeName>
        <Styled.SubmitButton
          size="small"
          mode="ghost"
          fullWidth={false}
        >
          {t('leading.agent.card.btn')}
        </Styled.SubmitButton>
      </Styled.AgentInfo>
    </Styled.Root>
  );
};
